export default {
  users_logs : 'Users logs',
  role:'role',
  last_login_date:'last login',
  last_logout_date :'last logout'
}
